export enum PortalClaim {
  // Base access for general portal use
  ACCESS_BASIC = 'portal:access:basic',

  // Permissions related to users
  MANAGE_USERS = 'portal:manage:users',

  // Payment processing and management
  PROCESS_PAYMENTS = 'portal:process:payments',
  MANAGE_PAYMENTS = 'portal:manage:payments',

  // Chargebacks
  MANAGE_CHARGEBACKS = 'portal:manage:chargebacks',

  // Reporting and finance
  VIEW_REPORTING = 'portal:view:reporting',
  VIEW_FINANCE = 'portal:view:finance',

  // Merchant management
  MANAGE_MERCHANTS = 'portal:manage:merchants',

  // System or environment configuration
  MANAGE_CONFIGURATION = 'portal:manage:configuration',
  MANAGE_BANKS = 'portal:manage:banks',
}
